import { PAGE_SIZE } from "../../../../constants/Config";
import {
    EMPLOYEE_TITLE_DELETE,
    EMPLOYEE_TITLE_DETAIL,
    EMPLOYEE_TITLE_INSERT,
    EMPLOYEE_TITLE_LIST,
    EMPLOYEE_TITLE_UPDATE,
    EMPLOYEE_TITLE_GET_ALL,
} from "./action-types";


const initialState = {
    data: [],
    totalRows: 0,
    currentPage: 0,
    pageSize: PAGE_SIZE,
    items: [],
    item: null,
    getAll: null,
    suggestion: []
}

const reducer = (state = initialState, { type, payload = null }) => {
    switch (type) {
        case EMPLOYEE_TITLE_LIST:
            return list(state, payload)
        case EMPLOYEE_TITLE_DETAIL:
            return detail(state, payload)
        case EMPLOYEE_TITLE_UPDATE:
            return update(state, payload)
        case EMPLOYEE_TITLE_INSERT:
            return insert(state, payload)
        case EMPLOYEE_TITLE_DELETE:
            return deletes(state, payload)
        case EMPLOYEE_TITLE_GET_ALL:
            return getAll(state, payload)
        default:
            return state;
    }
}

function list(state, payload) {
    state = Object.assign({}, state, payload);
    return state
}

function detail(state, payload) {
    state = Object.assign({}, state, {
        item: payload
    })
    return state
}

function deletes(state, payload) {
    const data = state.data.filter(obj => obj.id !== payload);
    return Object.assign({}, state, { data });
}

function update(state, payload) {
    const data = state.data.map(obj => {
        if (obj.id === payload.id) {
            return { ...obj, ...payload }
        }
        return obj
    })

    return Object.assign({}, state, { data })
}

function insert(state, payload) {
    const data = [...state.data, payload];
    return Object.assign({}, state, { data })
}

function getAll(state, payload) {
    state = Object.assign({}, state, {
        suggestion: payload
    })
    return state
}
export default reducer
